import React from 'react';
import { Form, Button } from 'react-bootstrap';

const FormCreator = ({
  formName,
  setFormName,
  onCreateForm
}) => {
  return (
    <Form className="mt-4">
      <Form.Group>
        <Form.Label>Create New Form</Form.Label>
        <Form.Control
          value={formName}
          onChange={(e) => setFormName(e.target.value)}
          placeholder="Form name"
        />
      </Form.Group>
      <Button className="mt-2" onClick={onCreateForm}>
        + Add Form
      </Button>
    </Form>
  );
};

export default FormCreator;
